import { createEventBus } from "@shared/features/eventBus/createEventBus";
import { Invitation } from "@platform/types/platform.types";

export type MarketingEvents = {
  "addInstitution:submit": { email: string; organization: string };
  "addInstitution:success": { email: string; organization: string };
  "hireUs:submit": { email: string; organization: string };
  "hireUs:success": { email: string; organization: string };
  "newsletter:submitted": { email: string; organization: string };
  "newsletter:subscribed": { email: string; organization: string };
  "marketing:invitation:direct:viewed": { invitation: Invitation };
  "marketing:invitation:direct:started": { invitation: Invitation };
};

export const marketingEventBus = createEventBus<MarketingEvents>();
